<template>
  <div>
    <div class="component-title">
      <div class="component-title">
        <h1 class="">ID Verification</h1>
      </div>
    </div>

    <form id="form6" autocomplete="off">
      <div class="row Introduce-yourself-container" style="margin-top:40px">
          <!--ID Verification-->
          <div class="row">
              <div class="col-sm-12 col-md-12">
                  <span>ID Verification</span>
                  <select name="idVerification2" id="id-verification2" required @change="switchVerifiation($event.target.value)">
                      <option value="passport-section" selected>Passport</option>
                      <option value="drivers-license">Drivers License</option>
                      <option value="birth-certificate">Birth Certificate</option>
                  </select>
              </div>
          </div>
          <!--Passport Number-->
          <div class="row pt-10 passport-section verification-option">
              <div class="col-sm-6 col-md-6 mt-10">
                  <span>Passport Number</span>
                  <input type="PassportNumber" name="PassportNumber" id="PassportNumber" class="" required="" autofocus="">
              </div>
              <div class="col-sm-6 col-md-6 mt-10">
                  <span>Country</span>
                  <select name="PassportCountry" id="PassportCountry" required>
                      <option value="usa" selected>USA</option>
                      <option value="aus">AUS</option>
                      <option value="uk">UK</option>
                  </select>
              </div>
              <div class="col-sm-6 col-md-6 mt-10">
                  <span>Country of tax residence</span>
                  <input type="CountryTax" name="CountryTax" id="CountryTax" class="" required="" autofocus="">
              </div>
              <div class="col-sm-6 col-md-6 mt-10">
                  <span>Citizenship of</span>
                  <select name="Citizenship" id="Citizenship" required>
                      <option value="usa" selected>USA</option>
                      <option value="aus">AUS</option>
                      <option value="uk">UK</option>
                  </select>
              </div>
              <div class="col-sm-6 col-md-6 mt-10">
                  <span>Residency status</span>
                  <select name="Residency" id="Residency" required>
                      <option value="usa" selected>USA</option>
                      <option value="aus">AUS</option>
                      <option value="uk">UK</option>
                  </select>
              </div>
              <div class="col-sm-6 col-md-6 mt-10">
                  <span>Country of birth</span>
                  <select name="CountryOfBirth" id="CountryOfBirth" required>
                      <option value="usa" selected>USA</option>
                      <option value="aus">AUS</option>
                      <option value="uk">UK</option>
                  </select>
              </div>
              <div class="col-sm-6 col-md-6 mt-10">
                  <span>City of birth</span>
                  <select name="CityOfBirth" id="CityOfBirth" required>
                      <option value="usa" selected>USA</option>
                      <option value="aus">AUS</option>
                      <option value="uk">UK</option>
                  </select>
              </div>
          </div>

          <!-- Drivers License -->
          <div class="row pt-10 drivers-license verification-option none">
            <div class="col-sm-6 col-md-6 mt-10">
              <span>Drivers License Number</span>
              <input type="DriverLicenseNumber" name="DriverLicenseNumber" id="DriverLicenseNumber" class="" required="" autofocus="">
            </div>
            <div class="col-sm-6 col-md-6 mt-10">
              <span>License State</span>
              <select name="PassportCountry" id="PassportCountry" required>
                  <option value="nsw" selected>NSW</option>
                  <option value="vic">VIC</option>
                  <option value="act">ACT</option>
              </select>
            </div>
          </div>

          <!-- Birth Certificate -->
          <div class="row pt-10 birth-certificate verification-option none">
            <div class="col-sm-6 col-md-6 mt-10">
              <span>Birth Certificate Registration Number</span>
              <input type="BirthCertificateNumber" name="BirthCertificateNumber" id="BirthCertificateNumber" class="" required="" autofocus="">
            </div>
            <div class="col-sm-6 col-md-6 mt-10">
              <span>Birth Certificate Registration State</span>
              <select name="BirthCertificateCountry" id="BirthCertificateCountry" required>
                <option value="usa" selected>USA</option>
                <option value="aus">AUS</option>
                <option value="uk">UK</option>
              </select>
            </div>
            <div class="col-sm-4 col-md-4 mt-10">
              <span>Registered first name</span>
              <input type="BirthCertificateFirstName" name="BirthCertificateFirstName" id="BirthCertificateFirstName" class="" required="" autofocus="">
            </div>
            <div class="col-sm-4 col-md-4 mt-10">
              <span>Registered middle name</span>
              <input type="BirthCertificateMiddleName" name="BirthCertificateMiddleName" id="BirthCertificateMiddleName" class="" autofocus="">
            </div>
            <div class="col-sm-4 col-md-4 mt-10">
              <span>Registered last name</span>
              <input type="BirthCertificateLastName" name="BirthCertificateLastName" id="BirthCertificateLastName" class="" required="" autofocus="">
            </div>
          </div>

          <div class="flx pt-20 mt-40">
              <div class="checked-box ps-relative">
                  <input name="checkBoxConfirm" type="checkbox" class="checkbox ps-center" required>
              </div>
              <p style="font-size: 20px; flex: 1">
                  I confirm that I am authorised to provide the personal details presented and <br>
                  I consent to my information being checked with the document issuer or <br>
                  official record holder via third party systems and services for the purpose <br>
                  of confirming my identity.
              </p>
          </div>
          <label id="checkBoxConfirm-error" class="error" for="checkBoxConfirm"></label>
      </div>
    </form>

    
    <div class="flx loan-container mt-60">
        <a type="button" class="continue-btn continue-btn-small steps-btn"
            href="#" @click.prevent="onContinue('repayment-account')">BACK</a>
        <a type="button"
            class="continue-btn continue-btn-small continue-btn-small-right steps-btn"
            href="#" @click.prevent="onContinue('residential-details')">CONTINUE</a>
    </div>
    <div class="mt-60 clear"></div>
    
  </div>
</template>

<script>
export default {
  props: ["onChangeStep"],
  methods: {
    switchVerifiation(verification) {
      console.log(verification);
      $(".verification-option").addClass("none");
      $("." + verification).removeClass("none");
    },
    onContinue(step) {
      this.onChangeStep(step);
    },
  },
};
</script>
